import { map, get, head } from 'lodash';
import React from 'react';

import ContentMatrix from '@/components/content-matrix';
import PageHeaderMatrix from '@/components/page-header-matrix';
import FeatureTilesListing from '@/components/feature-tiles-listing';
import Layout from '@/components/layout';
import { CACHE, CATEGORY_GROUPS, PAGE_SLUGS, SECTION_HANDLES, URLS } from '@/constants';
import { buildContentMatrixQuery, fetch } from '@/utils/api';
import { transformContentMatrix } from '@/utils/transform';
import { withAppProps, withAppProviders } from '@/utils/withAppProps';

const pageTitle = 'Safety Features';
const breadcrumbs = {
  title: pageTitle,
  ancestors: [{ title: 'Search', url: '/' }],
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'safetyFeatureGroups' implicitly has an 'any' type.
const SafetyFeatures = ({ safetyFeatureGroups, contentMatrices, removeFromCompare }) => {
  let { contentMatrix, pageHeaderMatrix } = contentMatrices[0];
  contentMatrix = transformContentMatrix(contentMatrix);
  pageHeaderMatrix = transformContentMatrix(pageHeaderMatrix);

  return (
    <Layout isHomePage={false} {...{ removeFromCompare }}>
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'elementMapping' is missing in type '{ blocks: any; breadcrumbs: { title: string; ancestors: { title: string; url: string; }[]; }; }' but required in type 'PageHeaderMatrixProps'. */}
      <PageHeaderMatrix blocks={pageHeaderMatrix} breadcrumbs={breadcrumbs} />
      {map(safetyFeatureGroups, ({ title: groupTitle, categoryDescription, tacSafetyFeatureEntries }) => (
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ heading: any; subHeading: any; featureTiles: { heading: any; body: any; detailUrl: string | null; iconUrl: undefined; }[]; key: any; }' is not assignable to type 'Pick<{ featureTiles?: never[] | undefined; heading: any; subHeading: any; }, "featureTiles">'.
        <FeatureTilesListing
          key={groupTitle}
          {...{
            heading: groupTitle,
            subHeading: categoryDescription,
            featureTiles: map(
              tacSafetyFeatureEntries,
              ({ title, featureDescription, featureIcon, slug, isPrimaryFeature }) => ({
                heading: title,
                body: featureDescription,
                detailUrl: isPrimaryFeature ? `${URLS.SAFETY_FEATURES_LISTING}/${slug}` : null,
                iconUrl: get(head(featureIcon), 'url'),
              })
            ),
          }}
        />
      ))}

      <ContentMatrix blocks={contentMatrix} />
    </Layout>
  );
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'preview' implicitly has an 'any' type.
const getStaticProps = withAppProps(async ({ preview, previewData }) => {
  const safetyFeaturesQuery = `{
    categories(group: "${CATEGORY_GROUPS.SAFETY_FEATURE_CATEGORIES}") {
      ... on safetyFeatureCategories_Category {
        title
        categoryDescription
        tacSafetyFeatureEntries {
          ... on tacSafetyFeatures_tacSafetyFeatures_Entry {
            featureDescription
            featureIcon {
              url
            }
            title
            slug
            isPrimaryFeature
          }
        }
      }
    }
  }
  `;

  const safetyFeaturesResponse = await fetch(
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object literal may only specify known properties, and 'query' does not exist in type '{ method: string; }'.
    { query: safetyFeaturesQuery },
    { params: { token: preview ? previewData?.previewToken : undefined } }
  );

  const contentMatrixQuery = buildContentMatrixQuery({
    section: SECTION_HANDLES.SAFETY_FEATURES,
    slug: PAGE_SLUGS.SAFETY_FEATURES,
  });
  const contentMatrixResponse = await fetch(
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object literal may only specify known properties, and 'query' does not exist in type '{ method: string; }'.
    { query: contentMatrixQuery },
    { params: { token: preview ? previewData?.previewToken : undefined } }
  );

  return {
    props: {
      safetyFeatureGroups: safetyFeaturesResponse.data.data.categories,
      contentMatrices: contentMatrixResponse.data.data.entries,
    },
    revalidate: CACHE.REVALIDATE,
  };
});

export default withAppProviders(SafetyFeatures);
export { getStaticProps };
